import VState from 'signal/v-state'

const centrePaneOverlayAnchorElementState = new VState(typeof window !== 'undefined' ? window.document.body : null)

export default centrePaneOverlayAnchorElementState
